import { _ep0, _mw0, command } from "../commandBuilder";
import { DeleteBaptism$ } from "../schemas/schemas_0";
export class DeleteBaptismCommand extends command(_ep0, _mw0, "DeleteBaptism", DeleteBaptism$) {
}
